import { useOrderContext } from "app/providers/OrderProvider";
import { useOrderBumbalData } from "app/hooks/appointment/useOrderBumbalData";
import { useEffect, useState } from "react";
import Card from "shared/ui/card";
import Container from "shared/ui/container";
import OrderLoader from "widgets/shared/order-loader";
import { isValidType } from "shared/utils/appointment-types";
import AppointmentFooter from "features/appointment-footer";
import ContactCustomerService from "widgets/shared/contact-customer-service";
import NoAppointment from "./partials/no-appointment";
import HasAppointment from "../status/post-checkout-appointment/has-appointment";
import { useSearchParams } from "react-router-dom";
import { StandardOrderAppointmentPage } from "./partials/StandardOrderAppointmentPage";
import { BumbalType } from "widgets/checkout/standard-product-date-picker/standard-product-shipment-delivery-date-picker";

const Appointment = () => {
  const { isOrderFetching, type } = useOrderContext();
  const {
    isOrderBumbalDataLoading,
    orderBumbalDataError,
    orderBumbalData,
    isOrderBumbalDataFetched,
  } = useOrderBumbalData();

  // TODO: extract to provider
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [hasAppointment, setHasAppointment] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!type || !isValidType(type)) {
      window.location.href = "https://gewoongers.nl/afspraak-aan-huis-maken/";
    }
  }, [type]);

  useEffect(() => {
    if (isOrderBumbalDataFetched) {
      onOrderBumbalDataFetched();
    }
  }, [isOrderBumbalDataFetched, orderBumbalData]);

  const onOrderBumbalDataFetched = () => {
    if (orderBumbalData && orderBumbalData.bumbalId) {
      setHasAppointment(true);
    }
  };

  const standardOrderId = searchParams.get("standardOrderId");
  const bumbalType = searchParams.get("type") as BumbalType;
  if (standardOrderId && bumbalType) {
    return (
      <StandardOrderAppointmentPage
        standardOrderId={standardOrderId}
        bumbalType={bumbalType}
      />
    );
  }

  return (
    <>
      {isOrderFetching || isOrderBumbalDataLoading ? (
        <Container>
          <Card className="gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-24">
            <OrderLoader />
          </Card>
        </Container>
      ) : orderBumbalDataError ? (
        <ContactCustomerService />
      ) : hasAppointment ? (
        <HasAppointment />
      ) : (
        <NoAppointment
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          setHasAppointment={setHasAppointment}
        />
      )}

      {!isOrderBumbalDataLoading && !hasAppointment ? (
        <AppointmentFooter selectedDate={selectedDate} />
      ) : (
        <></>
      )}
    </>
  );
};
export default Appointment;
